import { render, staticRenderFns } from "./DetailReceipt.vue?vue&type=template&id=6bf075c0&scoped=true&"
import script from "./DetailReceipt.vue?vue&type=script&lang=ts&"
export * from "./DetailReceipt.vue?vue&type=script&lang=ts&"
import style0 from "./DetailReceipt.vue?vue&type=style&index=0&id=6bf075c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf075c0",
  null
  
)

export default component.exports